import { OdgovorResponse } from "../pages/api/utisak/odgovor";

export const istekaoOglas = async (link, title) => {
    await fetch(
        `https://hooks.slack.com/services/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`,
        {
            method: "POST",
            body: JSON.stringify({
                blocks: [
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `Novi istekao oglas za pogledati: ${title} <${link}|link>`,
                        },
                    },
                ],
            }),
        }
    );
};

export const slackNoviOdgovorKompanije = async (data: OdgovorResponse) => {
    if (process.env.NODE_ENV === "development") return;

    await fetch(
        `https://hooks.slack.com/services/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`,
        {
            method: "POST",
            body: JSON.stringify({
                blocks: [
                    {
                        type: "section",
                        fields: [
                            {
                                type: "mrkdwn",
                                text: `*Kompanija:*\n${data.companyName}`,
                            },
                        ],
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `*Odgovor kompanije:*\n${data.text}`,
                        },
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `<https://www.dzobs.com/kompanija/${data.companySlug}/iskustva|Pogledaj recenziju>`,
                        },
                    },
                ],
            }),
        }
    )
        .then((r) => r.json())
        .catch((er) => console.log(er));
};

export const slackNovaRecenzija = async (data) => {
    if (process.env.NODE_ENV === "development") return;

    await fetch(
        `https://hooks.slack.com/services/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`,
        {
            method: "POST",
            body: JSON.stringify({
                blocks: [
                    {
                        type: "section",
                        fields: [
                            {
                                type: "mrkdwn",
                                text: `*Kompanija:*\n${data.companyName}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Pozicija:*\n${data.title}`,
                            },
                        ],
                    },
                    {
                        type: "section",
                        fields: [
                            {
                                type: "mrkdwn",
                                text: `*Napredovanje:*\n${data.napredovanje}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Projekti:*\n${data.projekti}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Balans posao/zivot:*\n${data.balans}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Tech:*\n${data.tech}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Plata:*\n${data.plata}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Lični Razvoj:*\n${data.razvoj}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Medjuljudski odnosi:*\n${data.odnosi}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Tim:*\n${data.tim}`,
                            },
                        ],
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `*Pozitivno:*\n${data.prosText}`,
                        },
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `*Negativno:*\n${data.consText}`,
                        },
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `*Menadzment:*\n${data.menadzmentText}`,
                        },
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `<https://www.dzobs.com/kompanija/${data.companySlug}/iskustva|Pogledaj recenziju>`,
                        },
                    },
                ],
            }),
        }
    )
        .then((r) => r.json())
        .catch((er) => console.log(er));
};

export const slackNoviIntervju = async (data) => {
    if (process.env.NODE_ENV === "development") return;

    await fetch(
        `https://hooks.slack.com/services/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`,
        {
            method: "POST",
            body: JSON.stringify({
                blocks: [
                    {
                        type: "section",
                        fields: [
                            {
                                type: "mrkdwn",
                                text: `*Kompanija:*\n${data.companyName}`,
                            },
                            {
                                type: "mrkdwn",
                                text: `*Pozicija:*\n${data.title}`,
                            },
                        ],
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `*Ishod:*\n${data.ishod.label}`,
                        },
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `*level:*\n${data.levelId.label}`,
                        },
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `*Body:*\n${data.body}`,
                        },
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `*Menadzment:*\n${data.menadzmentText}`,
                        },
                    },
                    {
                        type: "section",
                        text: {
                            type: "mrkdwn",
                            text: `<https://www.dzobs.com/kompanija/${data.companySlug}/intervju|Pogledaj intervju>`,
                        },
                    },
                ],
            }),
        }
    );
};
